import { render, staticRenderFns } from "./fcBlog.vue?vue&type=template&id=22452a96&"
import script from "./fcBlog.vue?vue&type=script&lang=js&"
export * from "./fcBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports